import "./Teams.css";
import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../api/client";
import Card from "../../components/Card/Card";
import Loader from "../../components/Loader/Loader";

const STATUS_LABEL = {
  active: "Active",
  pre_elimination: "Pre-elimination",
  eliminated: "Eliminated",
};

export default function Teams() {
  const [teams, setTeams] = useState(null);
  const [error, setError] = useState("");
  const [query, setQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");

  useEffect(() => {
    let live = true;
    api
      .get("/admin/teams")
      .then((data) => live && setTeams(data))
      .catch((e) => live && setError(e.message));
    return () => {
      live = false;
    };
  }, []);

  const filtered = useMemo(() => {
    if (!teams) return [];
    const q = query.trim().toLowerCase();
    return teams.filter((team) => {
      if (statusFilter !== "all" && team.status !== statusFilter) return false;
      if (!q) return true;
      return (
        team.name.toLowerCase().includes(q) ||
        team.joinCode.toLowerCase().includes(q) ||
        team.members.some((m) => (m.email || "").toLowerCase().includes(q))
      );
    });
  }, [teams, query, statusFilter]);

  return (
    <div className="teams-page col">
      <div className="teams-head row">
        <div className="col">
          <h1 className="t-h1">Teams</h1>
          <p className="t-body-sm t-dim">Every team, every member, at a glance.</p>
        </div>
      </div>

      <div className="teams-filters row">
        <input
          className="teams-search"
          type="text"
          placeholder="Search by name, join code or member email"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        <div className="teams-status-filter row">
          {["all", "active", "pre_elimination", "eliminated"].map((s) => (
            <button
              key={s}
              type="button"
              className={`teams-status-btn${statusFilter === s ? " teams-status-btn-on" : ""}`}
              onClick={() => setStatusFilter(s)}
            >
              {s === "all" ? "All" : STATUS_LABEL[s]}
            </button>
          ))}
        </div>
      </div>

      {error ? <p className="t-body-sm teams-error" role="alert">{error}</p> : null}

      {!teams && !error ? <Loader inline /> : null}

      <div className="teams-list col">
        {filtered.map((team) => (
          <Link key={team.id} to={`/team/${team.id}`} className="team-row-link">
            <Card className={`team-row row team-row-${team.status}`}>
              <div className="team-row-main col">
                <div className="team-row-title-line row">
                  <span className="t-h4">{team.name}</span>
                  <span className={`team-status-tag team-status-tag-${team.status}`}>
                    {STATUS_LABEL[team.status]}
                  </span>
                </div>
                <span className="t-mono t-dimmer">{team.joinCode}</span>
              </div>
              <div className="team-row-stats row">
                <span className="team-row-stat t-body-sm t-dim">
                  {team.members.length} member{team.members.length === 1 ? "" : "s"}
                </span>
                <span className="team-row-stat t-body-sm t-dim">
                  {team.submissionCount} submission{team.submissionCount === 1 ? "" : "s"}
                </span>
                {team.result && team.result.placement ? (
                  <span className="team-row-stat t-body-sm t-dim">
                    Placed {team.result.placement}
                  </span>
                ) : null}
              </div>
            </Card>
          </Link>
        ))}
        {teams && !filtered.length ? (
          <p className="t-body-sm t-dimmer">No teams match.</p>
        ) : null}
      </div>
    </div>
  );
}
